import { share } from 'rxjs/operators';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { I18nData } from '@app/core/i18n/services';
import * as fromI18n from '@app/core/i18n/store/reducers';
import { Register, RegisterForm, PopinAuthShowed } from '@app/core/user/store/actions';
import * as reducers from '@app/core/user/store/reducers';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { logger } from 'codelyzer/util/logger';
import { Credentials, UserCreate } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-form-register',
  templateUrl: './form-register.component.html',
  styleUrls: ['./form-register.component.scss']
})
export class FormRegisterComponent implements OnInit {
  @Input()
  credentials: Credentials;
  @Input()
  popinForced: boolean;

  public isMobile = false;

  public displayPassword = false;
  public countries$: Observable<any>;

  public pending$: Observable<any>;
  public error: string;

  public registerForm: FormGroup;
  public firstname: FormControl;
  public country: FormControl;
  public civility: FormControl;
  public password: FormControl;
  public cgv: FormControl;

  public civilities = [
    { name: 'REGISTER_MODAL.CIVILITY_OPTION1', value: '1' },
    { name: 'REGISTER_MODAL.CIVILITY_OPTION2', value: '2' }
  ];

  public currentCountry: any;

  public isSocialRegistration: boolean;

  constructor(private ref: ChangeDetectorRef, private i18nData: I18nData, private store: Store<IAppState>) {}

  ngOnInit() {
    this.store.dispatch(new RegisterForm());

    this.isSocialRegistration = this.credentials.socialAccountType && this.credentials.socialAccountType === 'facebook';

    this.pending$ = this.store.pipe(select(reducers.isPending), share());

    this.store.pipe(select(fromI18n.getUserCountry)).subscribe(
      res => {
        this.currentCountry = res;
      },
      err => {
        logger.info('fromI18n.getUserCountry is not set on subscribe store', err);
      }
    );

    this.countries$ = this.i18nData.getCountries();

    this.createFormControls();
    this.createForm();
    this.error = null;

    this.store.pipe(select(reducers.getError)).subscribe(
      error => {
        if (error && error.error && error.error.errors && error.error.errors.detail) {
          this.error = error.error.errors.detail;
        }
      },
      err => {}
    );

    this.store.select('device').subscribe(
      res => {
        if (res) {
          this.isMobile = !res.isMdUp;
        }
      },
      err => {}
    );
    this.store.dispatch(
      new PopinAuthShowed({
        type: 'registration',
        forced: this.popinForced,
        isMobile: this.isMobile
      })
    );
  }

  createFormControls() {
    this.firstname = new FormControl('', [Validators.required]);
    this.civility = new FormControl(null, [Validators.required]);
    this.civility.setValue('2');
    this.country = new FormControl(this.currentCountry, [Validators.required]);
    this.cgv = new FormControl(false);

    if (!this.isSocialRegistration) {
      this.password = new FormControl('', [Validators.required]);
    }
  }

  createForm() {
    const formGroupConfig = {
      firstname: this.firstname,
      country: this.country,
      civility: this.civility,
      cgv: this.cgv
    };

    if (!this.isSocialRegistration) {
      formGroupConfig['password'] = this.password;
    }

    this.registerForm = new FormGroup(formGroupConfig);
  }

  onSubmit() {
    if (this.registerForm.valid) {
      if (!this.isSocialRegistration) {
        this.credentials.password = this.password.value;
      }

      const payload: UserCreate = {
        firstname: this.firstname.value,
        civility: this.civility.value,
        country: this.country.value['isoCode'],
        credentials: this.credentials
      };

      this.store.dispatch(new Register(payload));

      this.ref.detectChanges();
    }
  }

  togglePassword() {
    this.displayPassword = !this.displayPassword;
  }
}
